export var PLUGIN_NAME = '@amplitude/plugin-network-capture-browser';
export var AMPLITUDE_NETWORK_REQUEST_EVENT = '[Amplitude] Network Request';
//# sourceMappingURL=constants.js.map